"use strict";
/**
 * Do not edit directly
 * Generated on Thu, 10 Aug 2023 10:25:09 GMT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenName = void 0;
var TokenName;
(function (TokenName) {
    TokenName["BACKGROUND_STATIC_FLAT"] = "BACKGROUND_STATIC_FLAT";
    TokenName["BACKGROUND_STATIC_RAISED"] = "BACKGROUND_STATIC_RAISED";
    TokenName["BACKGROUND_STATIC_FLOATING"] = "BACKGROUND_STATIC_FLOATING";
    TokenName["BACKGROUND_STATIC_SUNKEN"] = "BACKGROUND_STATIC_SUNKEN";
    TokenName["BACKGROUND_STATIC_INVERSE"] = "BACKGROUND_STATIC_INVERSE";
    TokenName["BACKGROUND_INTERACTIVE_PRIMARY_DEFAULT"] = "BACKGROUND_INTERACTIVE_PRIMARY_DEFAULT";
    TokenName["BACKGROUND_INTERACTIVE_PRIMARY_HOVER"] = "BACKGROUND_INTERACTIVE_PRIMARY_HOVER";
    TokenName["BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE"] = "BACKGROUND_INTERACTIVE_PRIMARY_ACTIVE";
    TokenName["BACKGROUND_INTERACTIVE_SECONDARY_DEFAULT"] = "BACKGROUND_INTERACTIVE_SECONDARY_DEFAULT";
    TokenName["BACKGROUND_INTERACTIVE_SECONDARY_HOVER"] = "BACKGROUND_INTERACTIVE_SECONDARY_HOVER";
    TokenName["BACKGROUND_INTERACTIVE_SECONDARY_ACTIVE"] = "BACKGROUND_INTERACTIVE_SECONDARY_ACTIVE";
    TokenName["BACKGROUND_INTERACTIVE_DANGER_DEFAULT"] = "BACKGROUND_INTERACTIVE_DANGER_DEFAULT";
    TokenName["BACKGROUND_INTERACTIVE_DANGER_HOVER"] = "BACKGROUND_INTERACTIVE_DANGER_HOVER";
    TokenName["BACKGROUND_INTERACTIVE_DANGER_ACTIVE"] = "BACKGROUND_INTERACTIVE_DANGER_ACTIVE";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_DEFAULT"] = "BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_DEFAULT";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER"] = "BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_HOVER";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE"] = "BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_ACTIVE";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_DEFAULT"] = "BACKGROUND_INTERACTIVE_NEUTRAL_DEFAULT";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_HOVER"] = "BACKGROUND_INTERACTIVE_NEUTRAL_HOVER";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_ACTIVE"] = "BACKGROUND_INTERACTIVE_NEUTRAL_ACTIVE";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_DEFAULT"] = "BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_DEFAULT";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_HOVER"] = "BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_HOVER";
    TokenName["BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_ACTIVE"] = "BACKGROUND_INTERACTIVE_NEUTRAL_BOLD_ACTIVE";
    TokenName["BACKGROUND_ALERT_WARNING_PRIMARY"] = "BACKGROUND_ALERT_WARNING_PRIMARY";
    TokenName["BACKGROUND_ALERT_WARNING_SECONDARY"] = "BACKGROUND_ALERT_WARNING_SECONDARY";
    TokenName["BACKGROUND_ALERT_SUCCESS_PRIMARY"] = "BACKGROUND_ALERT_SUCCESS_PRIMARY";
    TokenName["BACKGROUND_ALERT_SUCCESS_SECONDARY"] = "BACKGROUND_ALERT_SUCCESS_SECONDARY";
    TokenName["BACKGROUND_ALERT_INFO_PRIMARY"] = "BACKGROUND_ALERT_INFO_PRIMARY";
    TokenName["BACKGROUND_ALERT_INFO_SECONDARY"] = "BACKGROUND_ALERT_INFO_SECONDARY";
    TokenName["BACKGROUND_ALERT_DANGER_PRIMARY"] = "BACKGROUND_ALERT_DANGER_PRIMARY";
    TokenName["BACKGROUND_ALERT_DANGER_SECONDARY"] = "BACKGROUND_ALERT_DANGER_SECONDARY";
    TokenName["BACKGROUND_ALERT_BASIC_PRIMARY"] = "BACKGROUND_ALERT_BASIC_PRIMARY";
    TokenName["BACKGROUND_ALERT_BASIC_SECONDARY"] = "BACKGROUND_ALERT_BASIC_SECONDARY";
    TokenName["BACKGROUND_ACCENT_PRIMARY"] = "BACKGROUND_ACCENT_PRIMARY";
    TokenName["BACKGROUND_ACCENT_SECONDARY"] = "BACKGROUND_ACCENT_SECONDARY";
    TokenName["BACKGROUND_DISABLED"] = "BACKGROUND_DISABLED";
    TokenName["BACKGROUND_BACKDROP"] = "BACKGROUND_BACKDROP";
    TokenName["BACKGROUND_BRAND"] = "BACKGROUND_BRAND";
    TokenName["TEXT_STATIC_PRIMARY"] = "TEXT_STATIC_PRIMARY";
    TokenName["TEXT_STATIC_SECONDARY"] = "TEXT_STATIC_SECONDARY";
    TokenName["TEXT_STATIC_TERTIARY"] = "TEXT_STATIC_TERTIARY";
    TokenName["TEXT_STATIC_INVERSE"] = "TEXT_STATIC_INVERSE";
    TokenName["TEXT_INTERACTIVE_DEFAULT"] = "TEXT_INTERACTIVE_DEFAULT";
    TokenName["TEXT_INTERACTIVE_HOVER"] = "TEXT_INTERACTIVE_HOVER";
    TokenName["TEXT_INTERACTIVE_ACTIVE"] = "TEXT_INTERACTIVE_ACTIVE";
    TokenName["TEXT_ALERT_DANGER"] = "TEXT_ALERT_DANGER";
    TokenName["TEXT_ALERT_WARNING"] = "TEXT_ALERT_WARNING";
    TokenName["TEXT_ALERT_SUCCESS"] = "TEXT_ALERT_SUCCESS";
    TokenName["TEXT_ALERT_INFO"] = "TEXT_ALERT_INFO";
    TokenName["TEXT_ALERT_BASIC"] = "TEXT_ALERT_BASIC";
    TokenName["TEXT_DISABLED"] = "TEXT_DISABLED";
    TokenName["BORDER_STATIC_PRIMARY"] = "BORDER_STATIC_PRIMARY";
    TokenName["BORDER_STATIC_SECONDARY"] = "BORDER_STATIC_SECONDARY";
    TokenName["BORDER_STATIC_INVERSE"] = "BORDER_STATIC_INVERSE";
    TokenName["BORDER_ALERT_BASIC"] = "BORDER_ALERT_BASIC";
    TokenName["BORDER_ALERT_SUCCESS"] = "BORDER_ALERT_SUCCESS";
    TokenName["BORDER_ALERT_INFO"] = "BORDER_ALERT_INFO";
    TokenName["BORDER_ALERT_DANGER"] = "BORDER_ALERT_DANGER";
    TokenName["BORDER_ALERT_WARNING"] = "BORDER_ALERT_WARNING";
    TokenName["BORDER_INTERACTIVE_PRIMARY_DEFAULT"] = "BORDER_INTERACTIVE_PRIMARY_DEFAULT";
    TokenName["BORDER_INTERACTIVE_PRIMARY_HOVER"] = "BORDER_INTERACTIVE_PRIMARY_HOVER";
    TokenName["BORDER_INTERACTIVE_PRIMARY_ACTIVE"] = "BORDER_INTERACTIVE_PRIMARY_ACTIVE";
    TokenName["BORDER_INTERACTIVE_SECONDARY_DEFAULT"] = "BORDER_INTERACTIVE_SECONDARY_DEFAULT";
    TokenName["BORDER_INTERACTIVE_SECONDARY_HOVER"] = "BORDER_INTERACTIVE_SECONDARY_HOVER";
    TokenName["BORDER_INTERACTIVE_SECONDARY_ACTIVE"] = "BORDER_INTERACTIVE_SECONDARY_ACTIVE";
    TokenName["BORDER_INTERACTIVE_BOLD_DEFAULT"] = "BORDER_INTERACTIVE_BOLD_DEFAULT";
    TokenName["BORDER_INTERACTIVE_BOLD_HOVER"] = "BORDER_INTERACTIVE_BOLD_HOVER";
    TokenName["BORDER_INTERACTIVE_BOLD_ACTIVE"] = "BORDER_INTERACTIVE_BOLD_ACTIVE";
    TokenName["BORDER_INTERACTIVE_FOCUS"] = "BORDER_INTERACTIVE_FOCUS";
    TokenName["BORDER_DISABLED"] = "BORDER_DISABLED";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_BASIC_BOLD"] = "LEGACY_SUPPORT_TAG_BACKGROUND_BASIC_BOLD";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_PRIMARY"] = "LEGACY_SUPPORT_TAG_BACKGROUND_PRIMARY";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_DENIM"] = "LEGACY_SUPPORT_TAG_BACKGROUND_DENIM";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_LIME"] = "LEGACY_SUPPORT_TAG_BACKGROUND_LIME";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_MUSTARD"] = "LEGACY_SUPPORT_TAG_BACKGROUND_MUSTARD";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_LAVENDER"] = "LEGACY_SUPPORT_TAG_BACKGROUND_LAVENDER";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_RUBY"] = "LEGACY_SUPPORT_TAG_BACKGROUND_RUBY";
    TokenName["LEGACY_SUPPORT_TAG_BACKGROUND_TANGERINE"] = "LEGACY_SUPPORT_TAG_BACKGROUND_TANGERINE";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_BASIC_BOLD"] = "LEGACY_SUPPORT_TAG_BORDER_BASIC_BOLD";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_PRIMARY"] = "LEGACY_SUPPORT_TAG_BORDER_PRIMARY";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_DENIM"] = "LEGACY_SUPPORT_TAG_BORDER_DENIM";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_LIME"] = "LEGACY_SUPPORT_TAG_BORDER_LIME";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_MUSTARD"] = "LEGACY_SUPPORT_TAG_BORDER_MUSTARD";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_LAVENDER"] = "LEGACY_SUPPORT_TAG_BORDER_LAVENDER";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_RUBY"] = "LEGACY_SUPPORT_TAG_BORDER_RUBY";
    TokenName["LEGACY_SUPPORT_TAG_BORDER_TANGERINE"] = "LEGACY_SUPPORT_TAG_BORDER_TANGERINE";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_BASIC_BOLD"] = "LEGACY_SUPPORT_TAG_TEXT_BASIC_BOLD";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_PRIMARY"] = "LEGACY_SUPPORT_TAG_TEXT_PRIMARY";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_DENIM"] = "LEGACY_SUPPORT_TAG_TEXT_DENIM";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_LIME"] = "LEGACY_SUPPORT_TAG_TEXT_LIME";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_MUSTARD"] = "LEGACY_SUPPORT_TAG_TEXT_MUSTARD";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_LAVENDER"] = "LEGACY_SUPPORT_TAG_TEXT_LAVENDER";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_RUBY"] = "LEGACY_SUPPORT_TAG_TEXT_RUBY";
    TokenName["LEGACY_SUPPORT_TAG_TEXT_TANGERINE"] = "LEGACY_SUPPORT_TAG_TEXT_TANGERINE";
    TokenName["PALETTE_BRAND_INDIGO_25"] = "PALETTE_BRAND_INDIGO_25";
    TokenName["PALETTE_BRAND_INDIGO_50"] = "PALETTE_BRAND_INDIGO_50";
    TokenName["PALETTE_BRAND_INDIGO_100"] = "PALETTE_BRAND_INDIGO_100";
    TokenName["PALETTE_BRAND_INDIGO_150"] = "PALETTE_BRAND_INDIGO_150";
    TokenName["PALETTE_BRAND_INDIGO_200"] = "PALETTE_BRAND_INDIGO_200";
    TokenName["PALETTE_BRAND_INDIGO_300"] = "PALETTE_BRAND_INDIGO_300";
    TokenName["PALETTE_BRAND_INDIGO_400"] = "PALETTE_BRAND_INDIGO_400";
    TokenName["PALETTE_BRAND_INDIGO_500"] = "PALETTE_BRAND_INDIGO_500";
    TokenName["PALETTE_BRAND_INDIGO_600"] = "PALETTE_BRAND_INDIGO_600";
    TokenName["PALETTE_BRAND_INDIGO_700"] = "PALETTE_BRAND_INDIGO_700";
    TokenName["PALETTE_BRAND_INDIGO_800"] = "PALETTE_BRAND_INDIGO_800";
    TokenName["PALETTE_BRAND_INDIGO_900"] = "PALETTE_BRAND_INDIGO_900";
    TokenName["PALETTE_BRAND_INDIGO_1000"] = "PALETTE_BRAND_INDIGO_1000";
    TokenName["PALETTE_BRAND_NIGHT_0"] = "PALETTE_BRAND_NIGHT_0";
    TokenName["PALETTE_BRAND_NIGHT_25"] = "PALETTE_BRAND_NIGHT_25";
    TokenName["PALETTE_BRAND_NIGHT_50"] = "PALETTE_BRAND_NIGHT_50";
    TokenName["PALETTE_BRAND_NIGHT_100"] = "PALETTE_BRAND_NIGHT_100";
    TokenName["PALETTE_BRAND_NIGHT_150"] = "PALETTE_BRAND_NIGHT_150";
    TokenName["PALETTE_BRAND_NIGHT_200"] = "PALETTE_BRAND_NIGHT_200";
    TokenName["PALETTE_BRAND_NIGHT_300"] = "PALETTE_BRAND_NIGHT_300";
    TokenName["PALETTE_BRAND_NIGHT_400"] = "PALETTE_BRAND_NIGHT_400";
    TokenName["PALETTE_BRAND_NIGHT_500"] = "PALETTE_BRAND_NIGHT_500";
    TokenName["PALETTE_BRAND_NIGHT_600"] = "PALETTE_BRAND_NIGHT_600";
    TokenName["PALETTE_BRAND_NIGHT_700"] = "PALETTE_BRAND_NIGHT_700";
    TokenName["PALETTE_BRAND_NIGHT_800"] = "PALETTE_BRAND_NIGHT_800";
    TokenName["PALETTE_BRAND_NIGHT_900"] = "PALETTE_BRAND_NIGHT_900";
    TokenName["PALETTE_BRAND_NIGHT_1000"] = "PALETTE_BRAND_NIGHT_1000";
    TokenName["PALETTE_BRAND_NIGHT_1000_8"] = "PALETTE_BRAND_NIGHT_1000_8";
    TokenName["PALETTE_BRAND_NIGHT_1000_12"] = "PALETTE_BRAND_NIGHT_1000_12";
    TokenName["PALETTE_BRAND_NIGHT_1000_16"] = "PALETTE_BRAND_NIGHT_1000_16";
    TokenName["PALETTE_BRAND_CORAL_25"] = "PALETTE_BRAND_CORAL_25";
    TokenName["PALETTE_BRAND_CORAL_50"] = "PALETTE_BRAND_CORAL_50";
    TokenName["PALETTE_BRAND_CORAL_100"] = "PALETTE_BRAND_CORAL_100";
    TokenName["PALETTE_BRAND_CORAL_150"] = "PALETTE_BRAND_CORAL_150";
    TokenName["PALETTE_BRAND_CORAL_200"] = "PALETTE_BRAND_CORAL_200";
    TokenName["PALETTE_BRAND_CORAL_300"] = "PALETTE_BRAND_CORAL_300";
    TokenName["PALETTE_BRAND_CORAL_400"] = "PALETTE_BRAND_CORAL_400";
    TokenName["PALETTE_BRAND_CORAL_500"] = "PALETTE_BRAND_CORAL_500";
    TokenName["PALETTE_BRAND_CORAL_600"] = "PALETTE_BRAND_CORAL_600";
    TokenName["PALETTE_BRAND_CORAL_700"] = "PALETTE_BRAND_CORAL_700";
    TokenName["PALETTE_BRAND_CORAL_800"] = "PALETTE_BRAND_CORAL_800";
    TokenName["PALETTE_BRAND_CORAL_900"] = "PALETTE_BRAND_CORAL_900";
    TokenName["PALETTE_BRAND_CORAL_1000"] = "PALETTE_BRAND_CORAL_1000";
    TokenName["PALETTE_BRAND_GREY_0"] = "PALETTE_BRAND_GREY_0";
    TokenName["PALETTE_BRAND_GREY_25"] = "PALETTE_BRAND_GREY_25";
    TokenName["PALETTE_BRAND_GREY_50"] = "PALETTE_BRAND_GREY_50";
    TokenName["PALETTE_BRAND_GREY_100"] = "PALETTE_BRAND_GREY_100";
    TokenName["PALETTE_BRAND_GREY_150"] = "PALETTE_BRAND_GREY_150";
    TokenName["PALETTE_BRAND_GREY_200"] = "PALETTE_BRAND_GREY_200";
    TokenName["PALETTE_BRAND_GREY_300"] = "PALETTE_BRAND_GREY_300";
    TokenName["PALETTE_BRAND_GREY_400"] = "PALETTE_BRAND_GREY_400";
    TokenName["PALETTE_BRAND_GREY_500"] = "PALETTE_BRAND_GREY_500";
    TokenName["PALETTE_BRAND_GREY_600"] = "PALETTE_BRAND_GREY_600";
    TokenName["PALETTE_BRAND_GREY_700"] = "PALETTE_BRAND_GREY_700";
    TokenName["PALETTE_BRAND_GREY_800"] = "PALETTE_BRAND_GREY_800";
    TokenName["PALETTE_BRAND_GREY_900"] = "PALETTE_BRAND_GREY_900";
    TokenName["PALETTE_BRAND_GREY_1000"] = "PALETTE_BRAND_GREY_1000";
    TokenName["PALETTE_SEMANTIC_BLUE_25"] = "PALETTE_SEMANTIC_BLUE_25";
    TokenName["PALETTE_SEMANTIC_BLUE_50"] = "PALETTE_SEMANTIC_BLUE_50";
    TokenName["PALETTE_SEMANTIC_BLUE_100"] = "PALETTE_SEMANTIC_BLUE_100";
    TokenName["PALETTE_SEMANTIC_BLUE_150"] = "PALETTE_SEMANTIC_BLUE_150";
    TokenName["PALETTE_SEMANTIC_BLUE_200"] = "PALETTE_SEMANTIC_BLUE_200";
    TokenName["PALETTE_SEMANTIC_BLUE_300"] = "PALETTE_SEMANTIC_BLUE_300";
    TokenName["PALETTE_SEMANTIC_BLUE_400"] = "PALETTE_SEMANTIC_BLUE_400";
    TokenName["PALETTE_SEMANTIC_BLUE_500"] = "PALETTE_SEMANTIC_BLUE_500";
    TokenName["PALETTE_SEMANTIC_BLUE_600"] = "PALETTE_SEMANTIC_BLUE_600";
    TokenName["PALETTE_SEMANTIC_BLUE_700"] = "PALETTE_SEMANTIC_BLUE_700";
    TokenName["PALETTE_SEMANTIC_BLUE_800"] = "PALETTE_SEMANTIC_BLUE_800";
    TokenName["PALETTE_SEMANTIC_BLUE_900"] = "PALETTE_SEMANTIC_BLUE_900";
    TokenName["PALETTE_SEMANTIC_BLUE_1000"] = "PALETTE_SEMANTIC_BLUE_1000";
    TokenName["PALETTE_SEMANTIC_ORANGE_25"] = "PALETTE_SEMANTIC_ORANGE_25";
    TokenName["PALETTE_SEMANTIC_ORANGE_50"] = "PALETTE_SEMANTIC_ORANGE_50";
    TokenName["PALETTE_SEMANTIC_ORANGE_100"] = "PALETTE_SEMANTIC_ORANGE_100";
    TokenName["PALETTE_SEMANTIC_ORANGE_150"] = "PALETTE_SEMANTIC_ORANGE_150";
    TokenName["PALETTE_SEMANTIC_ORANGE_200"] = "PALETTE_SEMANTIC_ORANGE_200";
    TokenName["PALETTE_SEMANTIC_ORANGE_300"] = "PALETTE_SEMANTIC_ORANGE_300";
    TokenName["PALETTE_SEMANTIC_ORANGE_400"] = "PALETTE_SEMANTIC_ORANGE_400";
    TokenName["PALETTE_SEMANTIC_ORANGE_500"] = "PALETTE_SEMANTIC_ORANGE_500";
    TokenName["PALETTE_SEMANTIC_ORANGE_600"] = "PALETTE_SEMANTIC_ORANGE_600";
    TokenName["PALETTE_SEMANTIC_ORANGE_700"] = "PALETTE_SEMANTIC_ORANGE_700";
    TokenName["PALETTE_SEMANTIC_ORANGE_800"] = "PALETTE_SEMANTIC_ORANGE_800";
    TokenName["PALETTE_SEMANTIC_ORANGE_900"] = "PALETTE_SEMANTIC_ORANGE_900";
    TokenName["PALETTE_SEMANTIC_ORANGE_1000"] = "PALETTE_SEMANTIC_ORANGE_1000";
    TokenName["PALETTE_SEMANTIC_GREEN_25"] = "PALETTE_SEMANTIC_GREEN_25";
    TokenName["PALETTE_SEMANTIC_GREEN_50"] = "PALETTE_SEMANTIC_GREEN_50";
    TokenName["PALETTE_SEMANTIC_GREEN_100"] = "PALETTE_SEMANTIC_GREEN_100";
    TokenName["PALETTE_SEMANTIC_GREEN_150"] = "PALETTE_SEMANTIC_GREEN_150";
    TokenName["PALETTE_SEMANTIC_GREEN_200"] = "PALETTE_SEMANTIC_GREEN_200";
    TokenName["PALETTE_SEMANTIC_GREEN_300"] = "PALETTE_SEMANTIC_GREEN_300";
    TokenName["PALETTE_SEMANTIC_GREEN_400"] = "PALETTE_SEMANTIC_GREEN_400";
    TokenName["PALETTE_SEMANTIC_GREEN_500"] = "PALETTE_SEMANTIC_GREEN_500";
    TokenName["PALETTE_SEMANTIC_GREEN_600"] = "PALETTE_SEMANTIC_GREEN_600";
    TokenName["PALETTE_SEMANTIC_GREEN_700"] = "PALETTE_SEMANTIC_GREEN_700";
    TokenName["PALETTE_SEMANTIC_GREEN_800"] = "PALETTE_SEMANTIC_GREEN_800";
    TokenName["PALETTE_SEMANTIC_GREEN_900"] = "PALETTE_SEMANTIC_GREEN_900";
    TokenName["PALETTE_SEMANTIC_GREEN_1000"] = "PALETTE_SEMANTIC_GREEN_1000";
    TokenName["PALETTE_SEMANTIC_RED_25"] = "PALETTE_SEMANTIC_RED_25";
    TokenName["PALETTE_SEMANTIC_RED_50"] = "PALETTE_SEMANTIC_RED_50";
    TokenName["PALETTE_SEMANTIC_RED_100"] = "PALETTE_SEMANTIC_RED_100";
    TokenName["PALETTE_SEMANTIC_RED_150"] = "PALETTE_SEMANTIC_RED_150";
    TokenName["PALETTE_SEMANTIC_RED_200"] = "PALETTE_SEMANTIC_RED_200";
    TokenName["PALETTE_SEMANTIC_RED_300"] = "PALETTE_SEMANTIC_RED_300";
    TokenName["PALETTE_SEMANTIC_RED_400"] = "PALETTE_SEMANTIC_RED_400";
    TokenName["PALETTE_SEMANTIC_RED_500"] = "PALETTE_SEMANTIC_RED_500";
    TokenName["PALETTE_SEMANTIC_RED_600"] = "PALETTE_SEMANTIC_RED_600";
    TokenName["PALETTE_SEMANTIC_RED_700"] = "PALETTE_SEMANTIC_RED_700";
    TokenName["PALETTE_SEMANTIC_RED_800"] = "PALETTE_SEMANTIC_RED_800";
    TokenName["PALETTE_SEMANTIC_RED_900"] = "PALETTE_SEMANTIC_RED_900";
    TokenName["PALETTE_SEMANTIC_RED_1000"] = "PALETTE_SEMANTIC_RED_1000";
    TokenName["PALETTE_DATAVIZ_DENIM_50"] = "PALETTE_DATAVIZ_DENIM_50";
    TokenName["PALETTE_DATAVIZ_DENIM_100"] = "PALETTE_DATAVIZ_DENIM_100";
    TokenName["PALETTE_DATAVIZ_DENIM_200"] = "PALETTE_DATAVIZ_DENIM_200";
    TokenName["PALETTE_DATAVIZ_DENIM_300"] = "PALETTE_DATAVIZ_DENIM_300";
    TokenName["PALETTE_DATAVIZ_DENIM_400"] = "PALETTE_DATAVIZ_DENIM_400";
    TokenName["PALETTE_DATAVIZ_DENIM_500"] = "PALETTE_DATAVIZ_DENIM_500";
    TokenName["PALETTE_DATAVIZ_DENIM_600"] = "PALETTE_DATAVIZ_DENIM_600";
    TokenName["PALETTE_DATAVIZ_DENIM_700"] = "PALETTE_DATAVIZ_DENIM_700";
    TokenName["PALETTE_DATAVIZ_DENIM_800"] = "PALETTE_DATAVIZ_DENIM_800";
    TokenName["PALETTE_DATAVIZ_DENIM_900"] = "PALETTE_DATAVIZ_DENIM_900";
    TokenName["PALETTE_DATAVIZ_LAVENDER_50"] = "PALETTE_DATAVIZ_LAVENDER_50";
    TokenName["PALETTE_DATAVIZ_LAVENDER_100"] = "PALETTE_DATAVIZ_LAVENDER_100";
    TokenName["PALETTE_DATAVIZ_LAVENDER_200"] = "PALETTE_DATAVIZ_LAVENDER_200";
    TokenName["PALETTE_DATAVIZ_LAVENDER_300"] = "PALETTE_DATAVIZ_LAVENDER_300";
    TokenName["PALETTE_DATAVIZ_LAVENDER_400"] = "PALETTE_DATAVIZ_LAVENDER_400";
    TokenName["PALETTE_DATAVIZ_LAVENDER_500"] = "PALETTE_DATAVIZ_LAVENDER_500";
    TokenName["PALETTE_DATAVIZ_LAVENDER_600"] = "PALETTE_DATAVIZ_LAVENDER_600";
    TokenName["PALETTE_DATAVIZ_LAVENDER_700"] = "PALETTE_DATAVIZ_LAVENDER_700";
    TokenName["PALETTE_DATAVIZ_LAVENDER_800"] = "PALETTE_DATAVIZ_LAVENDER_800";
    TokenName["PALETTE_DATAVIZ_LAVENDER_900"] = "PALETTE_DATAVIZ_LAVENDER_900";
    TokenName["PALETTE_DATAVIZ_LIME_50"] = "PALETTE_DATAVIZ_LIME_50";
    TokenName["PALETTE_DATAVIZ_LIME_100"] = "PALETTE_DATAVIZ_LIME_100";
    TokenName["PALETTE_DATAVIZ_LIME_200"] = "PALETTE_DATAVIZ_LIME_200";
    TokenName["PALETTE_DATAVIZ_LIME_300"] = "PALETTE_DATAVIZ_LIME_300";
    TokenName["PALETTE_DATAVIZ_LIME_400"] = "PALETTE_DATAVIZ_LIME_400";
    TokenName["PALETTE_DATAVIZ_LIME_500"] = "PALETTE_DATAVIZ_LIME_500";
    TokenName["PALETTE_DATAVIZ_LIME_600"] = "PALETTE_DATAVIZ_LIME_600";
    TokenName["PALETTE_DATAVIZ_LIME_700"] = "PALETTE_DATAVIZ_LIME_700";
    TokenName["PALETTE_DATAVIZ_LIME_800"] = "PALETTE_DATAVIZ_LIME_800";
    TokenName["PALETTE_DATAVIZ_LIME_900"] = "PALETTE_DATAVIZ_LIME_900";
    TokenName["PALETTE_DATAVIZ_MUSTARD_50"] = "PALETTE_DATAVIZ_MUSTARD_50";
    TokenName["PALETTE_DATAVIZ_MUSTARD_100"] = "PALETTE_DATAVIZ_MUSTARD_100";
    TokenName["PALETTE_DATAVIZ_MUSTARD_200"] = "PALETTE_DATAVIZ_MUSTARD_200";
    TokenName["PALETTE_DATAVIZ_MUSTARD_300"] = "PALETTE_DATAVIZ_MUSTARD_300";
    TokenName["PALETTE_DATAVIZ_MUSTARD_400"] = "PALETTE_DATAVIZ_MUSTARD_400";
    TokenName["PALETTE_DATAVIZ_MUSTARD_500"] = "PALETTE_DATAVIZ_MUSTARD_500";
    TokenName["PALETTE_DATAVIZ_MUSTARD_600"] = "PALETTE_DATAVIZ_MUSTARD_600";
    TokenName["PALETTE_DATAVIZ_MUSTARD_700"] = "PALETTE_DATAVIZ_MUSTARD_700";
    TokenName["PALETTE_DATAVIZ_MUSTARD_800"] = "PALETTE_DATAVIZ_MUSTARD_800";
    TokenName["PALETTE_DATAVIZ_MUSTARD_900"] = "PALETTE_DATAVIZ_MUSTARD_900";
    TokenName["PALETTE_DATAVIZ_TANGERINE_50"] = "PALETTE_DATAVIZ_TANGERINE_50";
    TokenName["PALETTE_DATAVIZ_TANGERINE_100"] = "PALETTE_DATAVIZ_TANGERINE_100";
    TokenName["PALETTE_DATAVIZ_TANGERINE_200"] = "PALETTE_DATAVIZ_TANGERINE_200";
    TokenName["PALETTE_DATAVIZ_TANGERINE_300"] = "PALETTE_DATAVIZ_TANGERINE_300";
    TokenName["PALETTE_DATAVIZ_TANGERINE_400"] = "PALETTE_DATAVIZ_TANGERINE_400";
    TokenName["PALETTE_DATAVIZ_TANGERINE_500"] = "PALETTE_DATAVIZ_TANGERINE_500";
    TokenName["PALETTE_DATAVIZ_TANGERINE_600"] = "PALETTE_DATAVIZ_TANGERINE_600";
    TokenName["PALETTE_DATAVIZ_TANGERINE_700"] = "PALETTE_DATAVIZ_TANGERINE_700";
    TokenName["PALETTE_DATAVIZ_TANGERINE_800"] = "PALETTE_DATAVIZ_TANGERINE_800";
    TokenName["PALETTE_DATAVIZ_TANGERINE_900"] = "PALETTE_DATAVIZ_TANGERINE_900";
    TokenName["PALETTE_DATAVIZ_RUBY_50"] = "PALETTE_DATAVIZ_RUBY_50";
    TokenName["PALETTE_DATAVIZ_RUBY_100"] = "PALETTE_DATAVIZ_RUBY_100";
    TokenName["PALETTE_DATAVIZ_RUBY_200"] = "PALETTE_DATAVIZ_RUBY_200";
    TokenName["PALETTE_DATAVIZ_RUBY_300"] = "PALETTE_DATAVIZ_RUBY_300";
    TokenName["PALETTE_DATAVIZ_RUBY_400"] = "PALETTE_DATAVIZ_RUBY_400";
    TokenName["PALETTE_DATAVIZ_RUBY_500"] = "PALETTE_DATAVIZ_RUBY_500";
    TokenName["PALETTE_DATAVIZ_RUBY_600"] = "PALETTE_DATAVIZ_RUBY_600";
    TokenName["PALETTE_DATAVIZ_RUBY_700"] = "PALETTE_DATAVIZ_RUBY_700";
    TokenName["PALETTE_DATAVIZ_RUBY_800"] = "PALETTE_DATAVIZ_RUBY_800";
    TokenName["PALETTE_DATAVIZ_RUBY_900"] = "PALETTE_DATAVIZ_RUBY_900";
    TokenName["PALETTE_BASICS_BLACK"] = "PALETTE_BASICS_BLACK";
    TokenName["PALETTE_BASICS_WHITE"] = "PALETTE_BASICS_WHITE";
    TokenName["PALETTE_BASICS_WHITE_64"] = "PALETTE_BASICS_WHITE_64";
    TokenName["STATIC_CONTAINER_COLOR"] = "STATIC_CONTAINER_COLOR";
    TokenName["STATIC_CONTAINER_WIDTH"] = "STATIC_CONTAINER_WIDTH";
    TokenName["STATIC_DIVIDER_COLOR"] = "STATIC_DIVIDER_COLOR";
    TokenName["STATIC_DIVIDER_WIDTH"] = "STATIC_DIVIDER_WIDTH";
    TokenName["INPUT_DEFAULT_COLOR"] = "INPUT_DEFAULT_COLOR";
    TokenName["INPUT_DEFAULT_WIDTH"] = "INPUT_DEFAULT_WIDTH";
    TokenName["INPUT_HOVER_COLOR"] = "INPUT_HOVER_COLOR";
    TokenName["INPUT_HOVER_WIDTH"] = "INPUT_HOVER_WIDTH";
    TokenName["INPUT_ACTIVE_COLOR"] = "INPUT_ACTIVE_COLOR";
    TokenName["INPUT_ACTIVE_WIDTH"] = "INPUT_ACTIVE_WIDTH";
    TokenName["INPUT_DANGER_COLOR"] = "INPUT_DANGER_COLOR";
    TokenName["INPUT_DANGER_WIDTH"] = "INPUT_DANGER_WIDTH";
    TokenName["INPUT_INVERSE_COLOR"] = "INPUT_INVERSE_COLOR";
    TokenName["INPUT_INVERSE_WIDTH"] = "INPUT_INVERSE_WIDTH";
    TokenName["INPUT_DISABLED_COLOR"] = "INPUT_DISABLED_COLOR";
    TokenName["INTERACTIVE_DEFAULT_COLOR"] = "INTERACTIVE_DEFAULT_COLOR";
    TokenName["INTERACTIVE_DEFAULT_WIDTH"] = "INTERACTIVE_DEFAULT_WIDTH";
    TokenName["INTERACTIVE_HOVER_COLOR"] = "INTERACTIVE_HOVER_COLOR";
    TokenName["INTERACTIVE_HOVER_WIDTH"] = "INTERACTIVE_HOVER_WIDTH";
    TokenName["INTERACTIVE_DISABLED_COLOR"] = "INTERACTIVE_DISABLED_COLOR";
    TokenName["INTERACTIVE_DISABLED_WIDTH"] = "INTERACTIVE_DISABLED_WIDTH";
    TokenName["INTERACTIVE_INVERSE_COLOR"] = "INTERACTIVE_INVERSE_COLOR";
    TokenName["INTERACTIVE_INVERSE_WIDTH"] = "INTERACTIVE_INVERSE_WIDTH";
    TokenName["INTERACTIVE_DANGER_COLOR"] = "INTERACTIVE_DANGER_COLOR";
    TokenName["INTERACTIVE_DANGER_WIDTH"] = "INTERACTIVE_DANGER_WIDTH";
    TokenName["SHADOW_0"] = "SHADOW_0";
    TokenName["SHADOW_100"] = "SHADOW_100";
    TokenName["SHADOW_200"] = "SHADOW_200";
    TokenName["SHADOW_300"] = "SHADOW_300";
    TokenName["FOCUS_OFFSET"] = "FOCUS_OFFSET";
    TokenName["FONT_SIZE_RATIO"] = "FONT_SIZE_RATIO";
    TokenName["FONT_SIZE_50"] = "FONT_SIZE_50";
    TokenName["FONT_SIZE_75"] = "FONT_SIZE_75";
    TokenName["FONT_SIZE_100"] = "FONT_SIZE_100";
    TokenName["FONT_SIZE_200"] = "FONT_SIZE_200";
    TokenName["FONT_SIZE_300"] = "FONT_SIZE_300";
    TokenName["FONT_SIZE_400"] = "FONT_SIZE_400";
    TokenName["FONT_SIZE_500"] = "FONT_SIZE_500";
    TokenName["FONT_SIZE_600"] = "FONT_SIZE_600";
    TokenName["FONT_SIZE_700"] = "FONT_SIZE_700";
    TokenName["FONT_SIZE_800"] = "FONT_SIZE_800";
    TokenName["FONT_SIZE_900"] = "FONT_SIZE_900";
    TokenName["FONT_SIZE_BASE"] = "FONT_SIZE_BASE";
    TokenName["FONT_FAMILY_UI"] = "FONT_FAMILY_UI";
    TokenName["FONT_WEIGHT_300"] = "FONT_WEIGHT_300";
    TokenName["FONT_WEIGHT_400"] = "FONT_WEIGHT_400";
    TokenName["FONT_WEIGHT_500"] = "FONT_WEIGHT_500";
    TokenName["FONT_WEIGHT_600"] = "FONT_WEIGHT_600";
    TokenName["LINE_HEIGHT_100"] = "LINE_HEIGHT_100";
    TokenName["LINE_HEIGHT_200"] = "LINE_HEIGHT_200";
    TokenName["LINE_HEIGHT_300"] = "LINE_HEIGHT_300";
    TokenName["LETTER_SPACING_CONDENSED"] = "LETTER_SPACING_CONDENSED";
    TokenName["LETTER_SPACING_DEFAULT"] = "LETTER_SPACING_DEFAULT";
    TokenName["LETTER_SPACING_WIDE"] = "LETTER_SPACING_WIDE";
    TokenName["TEXT_DECORATION_UNDERLINE"] = "TEXT_DECORATION_UNDERLINE";
    TokenName["HIGHLIGHT_L"] = "HIGHLIGHT_L";
    TokenName["HIGHLIGHT_M"] = "HIGHLIGHT_M";
    TokenName["HIGHLIGHT_S"] = "HIGHLIGHT_S";
    TokenName["TITLE_L"] = "TITLE_L";
    TokenName["TITLE_M"] = "TITLE_M";
    TokenName["TITLE_S"] = "TITLE_S";
    TokenName["BODY_L"] = "BODY_L";
    TokenName["BODY_L_STRONG"] = "BODY_L_STRONG";
    TokenName["BODY_L_UNDERLINED"] = "BODY_L_UNDERLINED";
    TokenName["BODY_L_STRONG_UNDERLINED"] = "BODY_L_STRONG_UNDERLINED";
    TokenName["BODY_M"] = "BODY_M";
    TokenName["BODY_M_STRONG"] = "BODY_M_STRONG";
    TokenName["BODY_M_UNDERLINED"] = "BODY_M_UNDERLINED";
    TokenName["BODY_M_STRONG_UNDERLINED"] = "BODY_M_STRONG_UNDERLINED";
    TokenName["BODY_S"] = "BODY_S";
    TokenName["BODY_S_STRONG"] = "BODY_S_STRONG";
    TokenName["BODY_S_UNDERLINED"] = "BODY_S_UNDERLINED";
    TokenName["BODY_S_STRONG_UNDERLINED"] = "BODY_S_STRONG_UNDERLINED";
    TokenName["BODY_XS"] = "BODY_XS";
    TokenName["BODY_XS_STRONG"] = "BODY_XS_STRONG";
    TokenName["BODY_XS_UNDERLINED"] = "BODY_XS_UNDERLINED";
    TokenName["SPACING_0"] = "SPACING_0";
    TokenName["SPACING_25"] = "SPACING_25";
    TokenName["SPACING_50"] = "SPACING_50";
    TokenName["SPACING_100"] = "SPACING_100";
    TokenName["SPACING_150"] = "SPACING_150";
    TokenName["SPACING_200"] = "SPACING_200";
    TokenName["SPACING_250"] = "SPACING_250";
    TokenName["SPACING_300"] = "SPACING_300";
    TokenName["SPACING_400"] = "SPACING_400";
    TokenName["SPACING_450"] = "SPACING_450";
    TokenName["SPACING_500"] = "SPACING_500";
    TokenName["SPACING_700"] = "SPACING_700";
    TokenName["SPACING_900"] = "SPACING_900";
    TokenName["SPACING_1200"] = "SPACING_1200";
    TokenName["BORDER_RADIUS_0"] = "BORDER_RADIUS_0";
    TokenName["BORDER_RADIUS_25"] = "BORDER_RADIUS_25";
    TokenName["BORDER_RADIUS_50"] = "BORDER_RADIUS_50";
    TokenName["BORDER_RADIUS_100"] = "BORDER_RADIUS_100";
    TokenName["BORDER_RADIUS_200"] = "BORDER_RADIUS_200";
    TokenName["BORDER_RADIUS_300"] = "BORDER_RADIUS_300";
    TokenName["BORDER_RADIUS_ROUND"] = "BORDER_RADIUS_ROUND";
    TokenName["BORDER_RADIUS_BASE"] = "BORDER_RADIUS_BASE";
    TokenName["SPACING_BASE"] = "SPACING_BASE";
    TokenName["BORDER_WIDTH_0"] = "BORDER_WIDTH_0";
    TokenName["BORDER_WIDTH_100"] = "BORDER_WIDTH_100";
    TokenName["BORDER_WIDTH_150"] = "BORDER_WIDTH_150";
    TokenName["BORDER_WIDTH_200"] = "BORDER_WIDTH_200";
    TokenName["BORDER_WIDTH_250"] = "BORDER_WIDTH_250";
    TokenName["BORDER_WIDTH_300"] = "BORDER_WIDTH_300";
    TokenName["BORDER_STYLE_SOLID_STYLE"] = "BORDER_STYLE_SOLID_STYLE";
    TokenName["BORDER_STYLE_DOTTED_STYLE"] = "BORDER_STYLE_DOTTED_STYLE";
    TokenName["SIZING_BASE"] = "SIZING_BASE";
    TokenName["SIZING_200"] = "SIZING_200";
    TokenName["SIZING_300"] = "SIZING_300";
    TokenName["SIZING_400"] = "SIZING_400";
    TokenName["SIZING_500"] = "SIZING_500";
    TokenName["SIZING_550"] = "SIZING_550";
    TokenName["SIZING_600"] = "SIZING_600";
    TokenName["SIZING_900"] = "SIZING_900";
    TokenName["OPACITY_0"] = "OPACITY_0";
    TokenName["OPACITY_100"] = "OPACITY_100";
    TokenName["OPACITY_150"] = "OPACITY_150";
    TokenName["OPACITY_200"] = "OPACITY_200";
    TokenName["OPACITY_400"] = "OPACITY_400";
    TokenName["OPACITY_600"] = "OPACITY_600";
    TokenName["OPACITY_800"] = "OPACITY_800";
    TokenName["OPACITY_1000"] = "OPACITY_1000";
})(TokenName || (exports.TokenName = TokenName = {}));
